module.exports = __webpack_public_path__ + "static/media/control_entre_carga1.2b261e10.svg";